<header>
  <app-nav-menu></app-nav-menu>
</header>
<main role="main" class="backg container-fluid">
  <div class="page_body">
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="_green text-start col-md-12 h4">Calculator - {{reportName}}</div>
      </div>
      <form [formGroup]="form" autocomplete="off">
        <div class="row mt-3">
          <div class="col-md-9 ps-0" align="left">
            <div class="card shadow upper_hyt card_left ms-0">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12 cardHeader">
                    <small style="letter-spacing: 0px; color: #555555;">Select the country and input the other key details below, to start calculating the estimated processing time of your patent application:</small>
                  </div>
                </div>
                <div class="row mt-5">
                  <mat-form-field class="col-md-3">
                    <mat-select class="w-100" id="countrySelect" formControlName="country" [(value)]="countryId" placeholder="Country" (selectionChange)="onCountryChanged($event)" required>
                      <mat-option *ngFor="let c of countries" [value]=c.id>{{c.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="col-md-3">
                    <mat-select class="w-100" formControlName="protectionType" [(value)]="protectionTypeId" placeholder="Type of Protection" (selectionChange)="onProtectionTypeChanged($event)" required>
                      <mat-option *ngFor="let p of protectionTypes" [value]=p.id>{{p.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="col-md-3">
                    <mat-select class="w-100" formControlName="filingRoute" [(value)]="filingRouteId" placeholder="Filing Route" (selectionChange)="onFilingRouteChanged($event)" required>
                      <mat-option *ngFor="let f of filingRoutes" [value]=f.id>{{f.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="col-md-3">
                    <mat-select formControlName="technicalField" [(value)]="technicalFieldId" placeholder="Technical field of the invention"
                                (selectionChange)="onTechnicalFieldChanged($event)" required>
                      <mat-option *ngFor="let f of technicalFields" [value]=f.id>{{f.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="row mt-4">
                  <mat-form-field class="col-md-3">
                    <input formControlName="filingDate" matInput [matDatepicker]="picker1" placeholder="{{getDatePlaceholder()}}" (dateInput)="onFilingDateChange($event)" (dateChange)="onFilingDateChange($event)" required
                           readonly="{{ !showFilingDate() }}" />
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1 disabled="{{ !showFilingDate() }}"></mat-datepicker>
                    <mat-error *ngIf="hasError('filingDate')">{{errorMessage['filingDate']}}</mat-error>
                  </mat-form-field>
                  <div class="col-md-9 text-end px-0">
                    <div class="row py-2 height">
                      <div class="col-md-4 py-2">
                        Estimated Grant Date:
                      </div>
                      <div class="col-md-8 grantDate">
                        <div class="alert alert-success text-center w-100">{{estimatedGrantDate}} &nbsp;</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-md-3">
            <div class="card shadow upper_hyt">
              <div class="card-body m-2 savedReportPane">
                <h6 class="align-middle"> <mat-icon>description</mat-icon> <strong> Saved Reports</strong></h6>
                <hr class="mt-2 mb-2">
                <div class="noSavedReportView" *ngIf="isSavedReportEmpty">
                  <div class="iconforNoSavedReport"><mat-icon class="iconDisplay">description</mat-icon></div>
                  <p class="placeHolderReport">No Saved Report</p>
                </div>
                <div class="savedreportList">
                  <ul *ngFor="let item of calculatorData; index as i" class="list-group list-group-flush">
                    <li class="list-group-item d-flex align-items-center border-bottom pt-2 pb-0" id="{{'savereport-' + item.id}}" style="overflow: hidden;">
                      <div class="row savedReportsList">
                        <ng-template [ngIf]="showFormButtons()">
                          <div class="col-1 d-flex justify-content-center align-items-center">
                            <mat-checkbox [checked]="selectedItems.has(item.id)" (change)="toggleSelection(item.id)"></mat-checkbox>
                          </div>
                        </ng-template>
                        <div class="col-8 listholder">
                          <a href="{{'/?id=' + item.id}}">{{ item.filename }}</a>
                        </div>
                        <div class="col-3 deleteIcon text-end">
                          <button mat-icon-button (click)="deleteReport(item.id)" matTooltip="Delete" type="button">
                            <mat-icon>delete_outline</mat-icon>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 timelineHolder">
            <div class="row">
              <ng-template [ngIf]="showFormButtons()">
                <div class="col-6 text-start">
                  <h5>Grant Timeline</h5>
                </div>
              </ng-template>
              <div class="col-6 text-end">
                <ng-template [ngIf]="showFormButtons()">
                  <button (click)="sendSelected()" [disabled]="selectedItems.size === 0" mat-raised-button color="basic" class="ms-2"><mat-icon>email</mat-icon>SEND REPORT ({{ selectedItems.size }})</button>
                  <button (click)="onSave()" mat-raised-button color="basic" class="ms-2"><mat-icon>save</mat-icon>SAVE</button>
                  <button (click)="reloadCurrentRoute()" mat-raised-button color="basic" class="ms-2">RESET FORM</button>
                  <button (click)="print()" mat-raised-button color="basic" class="ms-2" hidden><mat-icon>print</mat-icon>PRINT</button>
                </ng-template>
              </div>
            </div>

            <ng-template [ngIf]="timeline.data.length > 0">
              <div class="card mt-3 mb-5">
                <div [class.blur]="isGeneratingCharts">
                  <div class="card-body">

                    <mat-slide-toggle checked="showGrid"
                                      (change)="onToggleChange($event)">
                      Show Tabulated Pendency Results
                    </mat-slide-toggle>

                    <div *ngIf="showGrid">

                      <div *ngIf="isCostNotNull else costIsNull">
                        <div class="row bg-secondary text-white h6">
                          <div class="col-1 col-custom-toggle"></div>
                          <div class="col-3 col-custom-step"><p class="lead ">STEP / ACTIVITY</p></div>
                          <div class="col-2 text-end col-custom-fee"><p class="lead  align-middle">OFFICIAL FEE (USD)</p></div>
                          <div class="col-2 text-end col-custom-fee"><p class="lead  align-middle">PROFESSIONAL FEE (USD)</p></div>
                          <div class="col-2 text-end col-custom-fee"><p class="lead  align-middle">SUB-TOTAL FEE (USD)</p></div>
                          <div class="col-1 text-center col-custom-date"><p class="lead align-middle">FROM</p></div>
                          <div class="col-1 text-center col-custom-date"><p class="lead align-middle">TO</p></div>
                        </div>

                        <ng-template ngFor let-step [ngForOf]="stepDurationData" let-i="index">
                          <ng-template #userInputs let-step let-i="i" let-isNotNormal="isNotNormal">
                            <div class="row table-row" *ngIf="hasSelectedInputs(step)"
                                 [ngClass]="{'steps-fixed-holder': step.type === 'fixedSelection'}">

                              <ng-container *ngFor="let input of step.userInput.values; let isFirst = first">
                                <ng-container *ngIf="input && input.selected">

                                  <!-- Empty toggle column -->
                                  <div class="col-1 col-custom-toggle row-compact" [ngClass]="{ 'first-input-row': isFirst && isNotNormal }">&nbsp;</div>

                                  <!-- input.name + qty input under step.name -->
                                  <div class="col-5 col-custom-step row-compact" [ngClass]="{ 'first-input-row': isFirst && isNotNormal }">
                                    <div class="d-flex align-items-center ms-3">
                                      <span>&bull; {{ input.name }}</span>
                                      <ng-container *ngIf="input.descriptionText">
                                        <mat-icon class="info-icon me-0 custom-info-icon" matTooltip="{{ input.descriptionText }}" matTooltipPosition="above" matTooltipClass="item-tooltip">
                                          info
                                        </mat-icon>
                                      </ng-container>
                                      <div class="col-4 custom-input-wrapper d-flex align-items-center">
                                        <input matInput
                                               type="number"
                                               [(ngModel)]="input.qty"
                                               (change)="onQtyChange($event, input, i)"
                                               (keydown)="preventNegative($event)"
                                               (wheel)="onWheel($event)"
                                               [min]="0"
                                               [ngModelOptions]="{standalone: true}"
                                               class="custom-inline-input no-border-input" />
                                      </div>

                                    </div>
                                  </div>

                                  <!-- input.totalOfficial under getDurationCost -->
                                  <div class="col-2 col-custom-fee d-flex align-items-center justify-content-end row-compact" [ngClass]="{ 'first-input-row': isFirst && isNotNormal }">
                                    <ng-container *ngIf="input.totalOfficial !== null && input.totalOfficial !== undefined">
                                      {{ formatUserInput(input.totalOfficial) }}
                                    </ng-container>
                                    <ng-container *ngIf="input.totalOfficial === null || input.totalOfficial === undefined">
                                      &nbsp;
                                    </ng-container>
                                  </div>

                                  <!-- input.totalProfessional under getProfessionalFee -->
                                  <div class="col-1 col-custom-fee d-flex align-items-center justify-content-end row-compact" [ngClass]="{ 'first-input-row': isFirst && isNotNormal }">
                                    <ng-container *ngIf="input.totalProfessional !== null && input.totalProfessional !== undefined">
                                      {{ formatUserInput(input.totalProfessional) }}
                                    </ng-container>
                                    <ng-container *ngIf="input.totalProfessional === null || input.totalProfessional === undefined">
                                      &nbsp;
                                    </ng-container>
                                  </div>

                                  <!-- Total -->
                                  <div class="col-1 col-custom-fee d-flex align-items-center justify-content-end row-compact" [ngClass]="{ 'first-input-row': isFirst && isNotNormal }">
                                    <ng-container *ngIf="input.totalOfficial !== null && input.totalProfessional !== null && input.totalOfficial !== undefined && input.totalProfessional !== undefined">
                                      {{ formatUserInput(input.totalOfficial + input.totalProfessional) }}
                                    </ng-container>
                                    <ng-container *ngIf="input.totalOfficial === null || input.totalProfessional === null || input.totalOfficial === undefined || input.totalProfessional === undefined">
                                      &nbsp;
                                    </ng-container>
                                  </div>

                                  <!-- Empty date columns (if keeping layout consistent) -->
                                  <div class="col-1 col-custom-date row-compact" [ngClass]="{ 'first-input-row': isFirst && isNotNormal }">&nbsp;</div>
                                  <div class="col-1 col-custom-date row-compact" [ngClass]="{ 'first-input-row': isFirst && isNotNormal }">&nbsp;</div>

                                </ng-container>
                              </ng-container>
                            </div>
                          </ng-template>
                          <ng-template [ngIf]="isNotNormalProcess(step.type)">
                            <div class="row table-row" [ngClass]="{'steps-fixed-holder': step.type === 'fixedSelection', 'table-row-no-border': hasSelectedInputs(step)}">
                              <!-- Toggle -->
                              <div class="col-1 col-custom-toggle">
                                <ng-template [ngIf]="step.type === 'option2' || step.type === 'option'">
                                  <mat-slide-toggle id="{{i}}"
                                                    [checked]="step.selected"
                                                    (change)="onSlideToggleChange($event)"
                                                    [disabled]="isDisabled(step)"
                                                    [color]="getToggleColor(step)">
                                  </mat-slide-toggle>
                                </ng-template>
                              </div>

                              <!-- Step Name + Select + User Input -->
                              <div class="col-3 col-custom-step">
                                <div>
                                  {{' ' + step.name}}
                                  <ng-template [ngIf]="step.type === 'option2' || step.type === 'fixedSelection'">
                                    <mat-select class="col-4 col-custom-step min-width-50"
                                                [(value)]="step.duration.true.selectedValueIndex"
                                                (selectionChange)="onSelectChanged($event, i)"
                                                [disabled]="step.selected === false">
                                      <mat-option *ngFor="let v of step.duration.true.values; let j = index" [value]="j"
                                                  [matTooltip]="step.duration.true.valueNames[j]" matTooltipPosition="above" matTooltipClass="item-tooltip">
                                        {{step.duration.true.valueNames[j]}}
                                      </mat-option>
                                    </mat-select>
                                  </ng-template>
                                </div>
                              </div>

                              <!-- Cost & Qty Column (Updated) -->
                              <div class="col-2 text-end col-custom-fee">
                                <div class="d-flex flex-column align-items-end" [style.color]="step.selected ? '#212529' : '#9D9D9D'">
                                  {{ getDurationCost(i) || '\u00A0' }}
                                </div>
                              </div>

                              <!-- Professional Fee -->
                              <div class="col-2 text-end col-custom-fee">
                                <div [style.color]="step.selected ? '#212529' : '#9D9D9D'">
                                  {{ getProfessionalFee(i) }}
                                </div>
                              </div>

                              <!-- Total -->
                              <div class="col-2 text-end col-custom-fee">
                                <div [style.color]="step.selected ? '#212529' : '#9D9D9D'">
                                  {{ calculateTotal(i) }}
                                </div>
                              </div>

                              <!-- Duration Dates -->
                              <ng-template [ngIf]="showDurationInfo(step)">
                                <div class="col-1 text-center col-custom-date">
                                  <span class="font-weight-light">{{step.result0.format('D MMMM YYYY') }}</span>
                                </div>
                                <div class="col-1 text-center col-custom-date">
                                  <span class="font-weight-light">{{step.result1.format('D MMMM YYYY') }}</span>
                                </div>
                              </ng-template>
                              <ng-template [ngIf]="!showDurationInfo(step)">
                                <div class="col-1 text-center col-custom-date"></div>
                                <div class="col-1 text-center col-custom-date"></div>
                              </ng-template>
                            </div>
                            <ng-container *ngTemplateOutlet="userInputs; context: { $implicit: step, i: i, isNotNormal: true  }"></ng-container>
                          </ng-template>

                          <ng-template [ngIf]="isNormalProcess(step.type)">
                            <div class="row table-row steps-fixed-holder" [ngClass]="{'table-row-no-border': hasSelectedInputs(step)}">
                              <div class="col-1 col-custom-toggle">

                              </div>
                              <div class="col-3 col-custom-step">
                                <div class="steps-fixed">{{' ' + step.name}}</div>
                              </div>
                              <div class="col-2 text-end col-custom-fee">
                                <div [style.color]="step.selected ? '#212529' : '#9D9D9D'">
                                  {{ getDurationCost(i) }}
                                </div>
                              </div>
                              <div class="col-2 text-end col-custom-fee">
                                <div [style.color]="step.selected ? '#212529' : '#9D9D9D'">
                                  {{ getProfessionalFee(i) }}
                                </div>
                              </div>
                              <div class="col-2 text-end col-custom-fee">
                                <div [style.color]="step.selected ? '#212529' : '#9D9D9D'">
                                  {{ calculateSubtotal(step) }}
                                </div>
                              </div>
                              <ng-template [ngIf]="showDurationInfo(step)">
                                <div class="col-1 text-center col-custom-date"><p class="font-weight-light noMargin">{{step.result0.format('D MMMM YYYY') }}</p></div>
                                <div class="col-1 text-center col-custom-date"><p class="font-weight-light noMargin">{{step.result1.format('D MMMM YYYY') }}</p></div>
                              </ng-template>
                              <ng-template [ngIf]="!showDurationInfo(step)">
                                <div class="col-1 text-center col-custom-date"></div>
                                <div class="col-1 text-center col-custom-date"></div>
                              </ng-template>
                            </div>
                            <ng-container *ngIf="hasSelectedInputs(step)">
                              <div class="steps-fixed-holder">
                                <ng-container *ngTemplateOutlet="userInputs; context: { $implicit: step, i: i, isNotNormal: false  }"></ng-container>
                              </div>
                            </ng-container>
                          </ng-template>
                        </ng-template>

                        <div class="row border">
                          <div class="col-1 col-custom-toggle"> </div>
                          <div class="col-3 col-custom-step"><p class="lead"><b>TOTAL FEES (USD):</b></p></div>
                          <div class="col-2 text-end col-custom-fee"><p class="lead">{{ totalCost }}</p></div>
                          <div class="col-2 text-end col-custom-fee"><p class="lead">{{ totalProfessional }}</p></div>
                          <div class="col-2 text-end col-custom-fee"><p class="lead">{{ subtotal }}</p></div>
                          <div class="col-2 text-center col-custom-date"><p class="lead"></p></div>
                          <div class="col-2 text-center col-custom-date"><p class="lead"></p></div>
                        </div>
                      </div>

                      <!--this can be refactored-->

                      <ng-template #costIsNull>
                        <div class="row bg-secondary text-white h6">
                          <div class="col-1"></div>
                          <div class="col-7"><p class="lead ">STEP / ACTIVITY</p></div>
                          <div class="col-2 text-center"><p class="lead align-middle">FROM</p></div>
                          <div class="col-2 text-center"><p class="lead align-middle">TO</p></div>
                        </div>

                        <ng-template ngFor let-step [ngForOf]="stepDurationData" let-i="index">
                          <ng-template [ngIf]="isNotNormalProcess(step.type)">
                            <div class="row table-row">
                              <div class="col-1">
                                <mat-slide-toggle id="{{i}}" checked="{{step.selected}}" (change)="onSlideToggleChange($event)" [disabled]="isDisabled(step)" color="green"></mat-slide-toggle>
                              </div>
                              <div class="col-7">
                                {{' ' + step.name}}
                                <ng-template [ngIf]="step.type === 'option2'">
                                  <mat-select class="col-4 min-width-50" [(value)]="step.duration.true.selectedValueIndex" (selectionChange)="onSelectChanged($event, i)" [disabled]="step.selected === false">
                                    <mat-option *ngFor="let v of step.duration.true.values; let j = index" [value]="j">
                                      {{step.duration.true.valueNames[j]}}
                                    </mat-option>
                                  </mat-select>
                                </ng-template>
                              </div>

                              <ng-template [ngIf]="showDurationInfo(step)">
                                <div class="col-2 text-center"><p class="font-weight-light ">{{step.result0}}</p></div>
                                <div class="col-2 text-center"><p class="font-weight-light ">{{step.result1}}</p></div>
                              </ng-template>
                              <ng-template [ngIf]="!showDurationInfo(step)">
                                <div class="col-2 text-center"></div>
                                <div class="col-2 text-center"></div>
                              </ng-template>
                            </div>
                          </ng-template>

                          <ng-template [ngIf]="isNormalProcess(step.type)">
                            <div class="row table-row steps-fixed-holder">
                              <div class="col-1">

                              </div>
                              <div class="col-7">
                                <div class="steps-fixed">{{' ' + step.name}}</div>
                              </div>
                              <ng-template [ngIf]="showDurationInfo(step)">
                                <div class="col-2 text-center"><p class="font-weight-light noMargin">{{step.result0}}</p></div>
                                <div class="col-2 text-center"><p class="font-weight-light noMargin">{{step.result1}}</p></div>
                              </ng-template>
                              <ng-template [ngIf]="!showDurationInfo(step)">
                                <div class="col-2 text-center"></div>
                                <div class="col-2 text-center"></div>
                              </ng-template>
                            </div>
                          </ng-template>
                        </ng-template>

                        <div class="row border nullFooter">
                          <div class="col-12"> </div>
                        </div>
                      </ng-template>
                    </div>

                    <p class="timelineDescription">Below details are the estimates based on the factors and data entered. Remember that this estimate is subject to change due to various factors that can affect the patent application process.</p>
                    <div id="timeline-container">
                      <google-chart style="width:100%; overflow: hidden;"
                                    title=""
                                    type="Timeline"
                                    [data]="timeline.data"
                                    [columns]="timeline.columnNames"
                                    [options]="timeline.options"
                                    (ready)="onChartReady($event)"
                                    (mouseover)="reapplyBorders($event)"
                                    (mouseleave)="reapplyBorders($event)"
                                    [dynamicResize]="true" class="mt-5" id="timelineChart">
                      </google-chart>
                    </div>

                  </div>
                </div>


              </div>
            </ng-template>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="remarks-body">
    <div class="remarks-holder">
      <div class="col-12">
        <ng-template [ngIf]="showFilingDate() && showStepDurations()">
          <div class="custom-content-holder" *ngIf="getCountrySpecificContent()">
            <div [innerHTML]="getCountrySpecificContent()"></div>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="row mt-5 mb-5">
      <div class="col-8 amicaHolder">
        <ng-template [ngIf]="getCountryLogoPath()">
          <div [ngClass]="{'custom-logo-holder': showSingaporeContent()}">
            <a [href]="getCountryLogoHref()" target="_blank">
              <img [src]="getCountryLogoPath()" alt="{{ form.country }} Logo" />
            </a>
          </div>
          <div class="custom-content-holder">
            <p>{{ getCountryLogoMessage() }}</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</main>

<footer>

  <patempoFooter></patempoFooter>

</footer>

<!-- Loading overlay -->
<div *ngIf="isGeneratingCharts" class="loading-overlay">
  <div class="loading-message">
    Generating timeline charts for the selected reports, please wait...
  </div>
</div>
